export enum MimeTypeEnum {
  ALPS = 'application/alps+json',
  HAL = 'application/hal+json',
  Json = 'application/json',
  Schema = 'application/schema+json',
}
